const FEATURES = {
  EXERCISES: 'exercises',
  SHEETS: 'sheets',
  EXERCISES_SETS: 'chosen_exercises',
};

export default FEATURES;
